import type { FooterIconName } from "@/components/Layout/footer/footerData";

interface FooterIconProps {
  name: FooterIconName;
}

export function FooterIcon({ name }: FooterIconProps) {
  if (name === "company") {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M3 21h18" />
        <rect x="4" y="10" width="6" height="11" rx="1" />
        <rect x="10" y="4" width="10" height="17" rx="1" />
        <path d="M7 13h.01" />
        <path d="M7 17h.01" />
        <path d="M14 8h.01" />
        <path d="M17 8h.01" />
        <path d="M14 12h.01" />
        <path d="M17 12h.01" />
        <path d="M14 16h.01" />
        <path d="M17 16h.01" />
      </svg>
    );
  }

  if (name === "contacts") {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <circle cx="9" cy="11" r="2" />
        <path d="M6.5 16a3 3 0 0 1 5 0" />
        <path d="M14 10h4" />
        <path d="M14 14h4" />
      </svg>
    );
  }

  if (name === "document") {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
        <path d="M14 3v6h6" />
        <path d="M8 13h8" />
        <path d="M8 17h6" />
      </svg>
    );
  }

  return null;
}
